var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfessionalsLookingUpskill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 63,
    viewBox: "0 0 68 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1228 -1387)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 42)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 63,
    rx: 12,
    transform: "translate(1228 1345)",
    fill: "#3488eb"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1245.998 1402.496)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,32H22a1,1,0,0,0,1-1V28h2a3,3,0,0,0,3-3V21.618L31.451,19.9a1,1,0,0,0,.385-1.45L28,12.691A12.995,12.995,0,0,0,4.453,5.414,1,1,0,1,0,6.074,6.586,11,11,0,0,1,26,13a1.006,1.006,0,0,0,.168.555l3.372,5.057-2.987,1.493A1,1,0,0,0,26,21v4a1,1,0,0,1-1,1H22a1,1,0,0,0-1,1v3H8V27.966A18.1,18.1,0,0,0,5.559,18.65a11,11,0,0,1-1.5-6.779,10.42,10.42,0,0,1,.287-1.62,1,1,0,1,0-1.936-.5,12.656,12.656,0,0,0-.342,1.927,12.969,12.969,0,0,0,1.775,8A16.1,16.1,0,0,1,6,27.966V31A1,1,0,0,0,7,32Z",
    transform: "translate(-1.999 0.008)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,28h2a1,1,0,0,0,0-2H12a1,1,0,0,0,0,2Z",
    transform: "translate(6.005 0.008)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.928,19h2.144A1.931,1.931,0,0,0,22,17.189a1.927,1.927,0,0,0,2.529-.761L25.6,14.572A1.933,1.933,0,0,0,24.993,12,1.933,1.933,0,0,0,25.6,9.428L24.528,7.572A1.927,1.927,0,0,0,22,6.811,1.931,1.931,0,0,0,20.072,5H17.928A1.929,1.929,0,0,0,16,6.811a1.927,1.927,0,0,0-2.53.762L12.4,9.428h0A1.933,1.933,0,0,0,13.007,12a1.933,1.933,0,0,0-.606,2.571l1.073,1.857a1.928,1.928,0,0,0,2.53.761A1.929,1.929,0,0,0,17.928,19ZM20,17H18a1.929,1.929,0,0,0-2.828-1.634l-1-1.733a1.928,1.928,0,0,0,0-3.266l1-1.733A1.929,1.929,0,0,0,18,7h2a1.929,1.929,0,0,0,2.828,1.633l1,1.734a1.928,1.928,0,0,0,0,3.266l-1,1.734A1.929,1.929,0,0,0,20,17ZM15.107,15.4ZM13.107,12.061ZM15.207,8.571Z",
    transform: "translate(-5.995 0.008)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,14a2,2,0,1,0-2-2A2,2,0,0,0,19,14Zm0-2Z",
    transform: "translate(-5.995 0.008)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfessionalsLookingUpskill);
export default __webpack_public_path__ + "static/media/professionals-looking-upskill.edfce38c90782d8dc1bb2b30583061ee.svg";
export { ForwardRef as ReactComponent };